import { useCurrentPlanApi } from "@/react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isPlanProfessional } from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

export const useShouldShowPlanTrial = () => {
  const { currentPlan } = useCurrentPlanApi();
  const { currentCommunitySettings } = usePunditUserContext();
  const { isCommunityOnTrial, isCommunityOnPaidPlan } = usePlanStatus();

  const isGrowthPlanTrialOptInEnabled = Boolean(
    currentCommunitySettings?.growth_plan_trial_opt_in_enabled,
  );

  const isPlanTrialActive = currentPlan?.plan_trial?.active || false;

  return (
    isGrowthPlanTrialOptInEnabled &&
    !isCommunityOnTrial &&
    !isPlanTrialActive &&
    isCommunityOnPaidPlan &&
    currentPlan &&
    isPlanProfessional(currentPlan.tier)
  );
};
